import { Injectable } from '@angular/core';
import { FileParameter, SituViewWebApiClient } from 'situview-webapi-client';
import { ConfigService } from './config.service';
import { FetchService } from './fetch.service';

@Injectable({ providedIn: 'root' })
export class CustomSituViewWebApiClient extends SituViewWebApiClient {
  constructor(private configService: ConfigService, private fetchService: FetchService) {
    super(configService.config.situViewWebApiBaseUrl, fetchService);
  }

  importProducts(companyId?: string | null | undefined, files?: FileParameter[] | null | undefined) {
    let url_ = this.configService.config.situViewWebApiBaseUrl + "/api/commands/ImportProducts";
    const content_ = new FormData();
    if (companyId) {
      content_.append("companyId", JSON.stringify(companyId));
    }
    if (files !== null && files !== undefined)
      files.forEach((item_: any) => {
        content_.append("files", item_.data, item_.fileName ? item_.fileName : "files")
      });
    let options_ = {
      body: content_,
      method: "POST",
      headers: {
        "Accept": "*/*",
      }
    };
    return this.fetchService.fetch(url_, options_).then((_response) => {
      return this.processImportProducts(_response);
    });
  }

  addHome(request: any, files: any) {
    let url_ = this.configService.config.situViewWebApiBaseUrl + "/api/commands/AddHome";
    const content_ = new FormData();
    if (request === undefined)
      throw new Error("The parameter 'request' must be defined.");
    else if (request !== null) {
      content_.append("request", JSON.stringify(request));
    }

    if (files !== null && files !== undefined)
      files.forEach((item_: any) => {
        content_.append("files", item_.data, item_.fileName ? item_.fileName : "files")
      });
    let options_ = {
      body: content_,
      method: "POST",
      headers: {
        "Accept": "*/*",
      }
    };
    return this.fetchService.fetch(url_, options_).then((_response) => {
      return this.processAddHome(_response);
    });
  }

  uploadFilesForHome(request: any, files: any) {
    let url_ = this.configService.config.situViewWebApiBaseUrl + "/api/commands/UploadFilesForHome";
    const content_ = new FormData();
    if (request === undefined)
      throw new Error("The parameter 'request' must be defined.");
    else if (request !== null) {
      content_.append("request", JSON.stringify(request));
    }

    if (files !== null && files !== undefined)
      files.forEach((item_: any) => {
        content_.append("files", item_.data, item_.fileName ? item_.fileName : "files")
      });
    let options_ = {
      body: content_,
      method: "POST",
      headers: {
        "Accept": "*/*",
      }
    };
    return this.fetchService.fetch(url_, options_).then((_response) => {
      return this.processUploadFilesForHome(_response);
    });
  }
}

export class AddHomeRequest implements IAddHomeRequest {
  builder?: string | undefined;
  homeName?: string | undefined;
  ifcFiles?: IfcFileModel[] | undefined;
}
export interface IAddHomeRequest {
  builder?: string | undefined;
  homeName?: string | undefined;
  ifcFiles?: IfcFileModel[] | undefined;
}

export class UploadFilesForHomeRequest implements IUploadFilesForHomeRequest {
  builder?: string | undefined;
  homeName?: string | undefined;
  ifcFiles?: IfcFileModel[] | undefined;
}
export interface IUploadFilesForHomeRequest {
  builder?: string | undefined;
  homeName?: string | undefined;
  ifcFiles?: IfcFileModel[] | undefined;
}

export declare class IfcFileModel implements IIfcFileModel {
  fileName?: string | undefined;
  ifcType?: IfcType;
  constructor(data?: IIfcFileModel);
  init(_data?: any, _mappings?: any): void;
  static fromJS(data: any, _mappings?: any): IfcFileModel | null;
  toJSON(data?: any): any;
}
export interface IIfcFileModel {
  fileName?: string | undefined;
  ifcType?: IfcType;
}
export declare enum IfcType {
  Master = 0,
  Option = 1
}
